import React, { useState, useEffect } from "react";
import { useParams, useNavigate, useLocation } from "react-router-dom";
import { Helmet } from 'react-helmet';
import config from '../configuration/config.json';
import axios from 'axios';
import { Spinner, Button, Row, Col, Alert } from 'react-bootstrap';
import { Base64 } from 'js-base64';
import './IDProofing.css';
import selfieicon from "../images/hid-icons-selfie.svg";
import imageCompression from 'browser-image-compression';
import NeurotechVerify from './NeurotechVerify';
import NeurotechMobileVerify from './NeurotechMobileVerify';

Base64.extendUint8Array();

function Selfi() {
    const title = 'goID ID Proofing Portal';
    const [isLoading, setIsLoading] = useState(false);
    const [show, setShow] = useState(false);
    const [errorMessage, setErrorMessage] = useState("");
    const [image, setImage] = useState("");
    const [imageType, setImageType] = useState("");
    //const [cardType, setCardType] = useState("");
    let { aid, cardType } = useParams();
    const navigate = useNavigate();
    const location = useLocation();

    // Parse response_code from URL hash (e.g. #response_code=xxx) or query string (e.g. ?response_code=xxx)
    
    if (!aid) {
        
        aid = new URLSearchParams(location.hash.replace('#', '?')).get('response_code')
            || new URLSearchParams(location.search).get('response_code');
    }

    //  useEffect(() => {
    //      let cardType = localStorage.getItem('CardType');
    //     setCardType(cardType);
    //  }, []);


    async function handleChange(e) {
        if (e.target.files && e.target.files[0]) {
            var FR = new FileReader();
            const imageFile = e.target.files[0];
            let imageType = imageFile.type.split('/')[1];
            setImageType(imageType);
            const options = {
                maxSizeMB: 0.02,
                maxWidthOrHeight: 1920,
                useWebWorker: true
            }
            const compressedFile = await imageCompression(imageFile, options);
            FR.onload = function (e) {

                var img = new Image();
                img.src = e.target.result;
                
                setImage(img.src);
                downloadImage(img.src, imageType);
            };
            FR.readAsDataURL(compressedFile);
        }
    }

    async function downloadImage(imageSrc, imageType) {
        let base64 = imageSrc.replace(/^data:image\/[a-z]+;base64,/, "");
        checkLivenesswithEAT(base64,imageType);
    }

    async function checkLivenesswithEAT(image, imageType) {
        try {
            localStorage.setItem('CardType', cardType);
            setIsLoading(true);
            let headers = {
                "content-type": "application/json",
                'Authorization': "Bearer " + config.idproofing.token
            };
            const response = await axios.request({
                method: 'POST',
                url: config.idproofing.apibaseurl + "idproofing/liveness/" + cardType+ "/"+ aid,
                headers: headers,
                responseType: 'application/json',
                data: {
                    "image": image,
                    "imageType": imageType
                }
            });
            
            if (response.status == 200) {
                navigate('/idproofing/verification/' + aid);
            }else {
                setIsLoading(false);
                let apiResponse = response.data;
                let jsonData = JSON.parse(apiResponse)
                setErrorMessage(jsonData.message);
                setShow(true);
            }

        } catch (e) {
            if (e.response != null && e.response.data != null) {
                let jsonData = JSON.parse(e.response.data);
                setErrorMessage(jsonData.message);
            }
            else { 
                setErrorMessage(e.message);
            }
            setShow(true);
            setIsLoading(false);
        }
    };

    return (
        <>
            <Helmet>
                <title>{title}</title>
            </Helmet>


            <main className="mainbg">

                <div class="container-fluid  text-center">
                    <div class="row">
                        <div class="col bannerdisplay">
                            
                            <div className="headerdiv">
                                <h1 className="headerdisplay">{title}</h1>
                            </div>

                        </div>
                    </div>

                    <div class="row">
                        <div class="col scancontentarea">
                            <div class="container-fluid">
                                <div class="row">
                                    <div class="col">
                                        <span className="scaninstructiondisplay">Your {cardType === '2' ? "eID" : "mobile document"} has been submitted. Please confirm your identity by taking a selfie.</span>
                                    </div>
                                </div>
                                {config.idproofing.livenessProvider === 'NEUROTECH' ? (
                                    React.createElement(config.idproofing.neurotech.captureMode === 'MOBILE' ? NeurotechMobileVerify : NeurotechVerify, {
                                        aid: aid,
                                        cardType: cardType,
                                        onSuccess: () => {
                                            localStorage.setItem('CardType', cardType);
                                            navigate('/idproofing/verification/' + aid);
                                        },
                                        onError: (message) => {
                                            setErrorMessage(message);
                                            setShow(true);
                                        }
                                    })
                                ) : (<>
                                <div class="row">
                                    <div class="col">
                                        {image == "" ? (
                                            <img src={selfieicon} thumbnail className='m-4' style={{ width: 320, height: 300 }}></img>

                                        ) : (
                                            <img src={image} thumbnail className='m-4' style={{ width: 320, height: 300 }} />
                                        )}
                                    </div>
                                </div>

                                <div class="row">
                                    <div class="col">
                                        {image != "" ? (
                                            <Button className="btn btn-primary btn-lg px-4 gap-3"
                                                disabled={isLoading}
                                                type="button"
                                                onClick={(e) => {
                                                    e.preventDefault();
                                                    setImage("");
                                                }}
                                            >
                                                <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" hidden={!isLoading} />
                                                <span className="px-2">Retake Image</span>
                                            </Button>
                                        ) : (
                                            <label htmlFor={'file'} className="btn btn-primary btn-lg px-4 gap-3">
                                                <span className="px-2">Take Selfie</span>
                                                <input type='file' id={'file'} style={{ display: 'none' }} onChange={handleChange} accept="image/*" capture="user" />
                                            </label>

                                        )}

                                    </div>
                                </div>
                                </>)}

                            </div>
                        </div>
                    </div>

                </div>
            </main>
           
            <Alert show={show} variant="danger" onClose={() => setShow(false)} dismissible>
                <Alert.Heading>Error!</Alert.Heading>
                <p>
                    {errorMessage}.
                </p>
            </Alert>
        </>
    );
}

export default Selfi;
